import React from "react";

export function AlertErrorComponent({ errorMsg }) {
  return (
    <div className="alert alert-danger my-10" role="alert">
      <i className="ph ph-warning me-3 align-middle fs-16"></i>
      {errorMsg}
    </div>
  );
}

export function AlertComponent({ errorArray = [] }) {
  return (
    <div className="alert alert-danger my-10" role="alert">
      <i className="ph ph-warning me-3 align-middle fs-16"></i>
      <span className="fw-semibold">Error/s with your submission</span>
      <ul className="m-0">
        {errorArray.map((err, index) => (
          <li className="p-1" key={index}>
            {err}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function AlertSuccessComponent({ message }) {
  return (
    <div className="alert alert-success mb-10 border-0" role="alert">
      {/* <i className="ph ph-warning me-3 align-middle fs-16"></i> */}
      {/* <span className="fw-semibold">Error/s with your submission</span> */}
      {message}
    </div>
  );
}
